import { Controller } from "@hotwired/stimulus";

// walk/DONATE.md § 1 video: a card until a tap.
//
// The card is a plain link to youtube.com; nothing of YouTube's loads with
// the page. A tap swaps it for one 16:9 iframe from youtube-nocookie.com, so
// Google hears of the visit when the person asked to play, not before.
// No JavaScript, no player — the link still goes where it says.
export default class extends Controller {
  static values = { id: String, title: String };

  play(event) {
    event.preventDefault();
    const frame = document.createElement("iframe");
    frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.idValue)}?autoplay=1`;
    frame.title = this.titleValue;
    frame.allow = "autoplay; encrypted-media; picture-in-picture";
    frame.allowFullscreen = true;
    frame.referrerPolicy = "strict-origin-when-cross-origin";
    frame.className = "size-full rounded-box border-0";
    this.card = [...this.element.childNodes];
    this.element.replaceChildren(frame);
    this.element.classList.remove("p-4");
  }

  // turbo:before-cache (the view's data-action): the snapshot Back draws
  // holds the card again, or the cached frame would autoplay with no tap.
  reset() {
    if (!this.card) return;
    this.element.replaceChildren(...this.card);
    this.element.classList.add("p-4");
    this.card = null;
  }
}
